import type { SvgProps } from "../types";

export const CameraSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 400 400" fill="none">
      <title>Camera</title>
      <path
        d="M105.676 129.417C187.216 117.927 282.27 124.988 292.467 129.417C302.664 133.846 309.045 258.962 301.172 265.501C293.299 272.041 109.975 293.21 105.676 282.356C101.376 271.502 91.3627 172.34 96.3695 157.049"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M168.732 172.972C206.647 119.637 275.799 205.514 227.206 240.666C189.446 267.983 145.115 225.405 162.843 188.357"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M189.743 191.456C204.988 176.165 222.531 205.237 204.07 213.465C189.621 219.903 180.861 203.74 189.743 194.242"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M253.031 116.608C256.765 114.464 263.856 114.464 274.305 116.608"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M259.107 158.709C259.107 158.709 262.134 157.351 266.705 158.709"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
